import React from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  blackShade19,
  blueColor101,
  border25,
  greyColor062,
  greyColor063,
  lightOrange02,
  yellowShade03,
} from "../../../configs/styles/muiThemes";

const MultiBranchInfo = ({ masterBranchInfo, branchInfo }) => {
  return (
    <Box
      sx={{
        p: "8px 15px 12px 15px",
        bgcolor: blueColor101,
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Typography
            fontSize={13.5}
            fontWeight={600}
            lineHeight="20px"
            color={blackShade19}
            sx={{ mb: "5px" }}
          >
            Headquarters
          </Typography>

          <Paper elevation={0} sx={styles.card}>
            <Typography
              fontSize={13}
              fontWeight={600}
              lineHeight="18px"
              color={blackShade19}
            >
              {masterBranchInfo?.masterBranchName || masterBranchInfo?.name}
            </Typography>

            <Box display='flex' alignItems='center' mt={0.2}>
              <Box sx={styles.countBox}>{branchInfo?.length}</Box>
              <Typography
                fontSize={11.5}
                fontWeight={400}
                lineHeight="22px"
                color={greyColor062}
              >
                Branches
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={9}>
          <Typography
            fontSize={13.5}
            fontWeight={600}
            lineHeight="20px"
            color={blackShade19}
            sx={{ mb: "5px" }}
          >
            Branches
          </Typography>

          <Box sx={styles.card}>
            <Grid container columnSpacing={2}>
              {branchInfo?.map((branch, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <ListItem disableGutters sx={{ p: 0 }}>
                    <ListItemIcon sx={{ minWidth: "24px" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{
                          color: yellowShade03,
                          fontSize: "8px",
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={branch?.businessName}
                      primaryTypographyProps={{
                        fontSize: 11.5,
                        fontWeight: 500,
                        color: greyColor063,
                        lineHeight: "16px",
                      }}
                    />
                  </ListItem>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MultiBranchInfo;

const styles = {
  card: {
    p: "11px 12px",
    bgcolor: "white",
    borderRadius: "10px",
    border: border25,

    height: "72px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "2px",
      height: "2px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "#d0d3da",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  countBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 600,
    lineHeight: "22px",
    color: yellowShade03,
    bgcolor: lightOrange02,
    p: "1px 8px",
    borderRadius: "5px",
    mr: "5px",
  },
};
